import React from 'react';
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import { Toolbar } from 'polotno/toolbar/toolbar';
import { ZoomButtons } from 'polotno/toolbar/zoom-buttons';
import { SidePanel, DEFAULT_SECTIONS } from 'polotno/side-panel';
import { Workspace } from 'polotno/canvas/workspace';
import { setUploadFunc } from 'polotno/config';
import SavedSection from '../components/savedDesigns';
import UploadSection from "../components/uploaded"
import {firestore, storage}from "../firebase"
import { loadJSONFile } from '../helpers/file';
import GCPPhotosTab from '../components/GCPPhotosTab';
import GCPCharactersTab from '../components/GCPCharactersTab';
import GCPIllustrationsTab from '../components/GCPIllustrationsTab';
import GCPQuotesTab from '../components/GCPQuotesTab';
import GCPGraphicsTab from '../components/GCPGraphicsTab';
import GCP3dCharactersTab from "../components/GCP3DcharactersTab";
DEFAULT_SECTIONS.splice(4,1)
const useHeight = () => {
  const [height, setHeight] = React.useState(window.innerHeight);
  React.useEffect(() => {
    window.addEventListener('resize', () => {
      setHeight(window.innerHeight);
    });
  }, []);
  return height;
};

async function upload(localFile) {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"))
  if (localFile.type.includes("image")) {
    const child = `${currentUser.uid}/uploaded/${localFile.name}-${new Date().getTime()}`
    const uploadSnapchot = await storage
        .ref()
        .child(child)
        .put(localFile);
      const imageLink = await uploadSnapchot.ref.getDownloadURL();
      await firestore.collection("uploaded").add({
        userId: currentUser.uid,
        url: imageLink,
      })
      return imageLink;
  }
  return null;
}
setUploadFunc(upload);


const App = ({store}) => {

  const handleDrop = (ev) => {
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < ev.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i].kind === 'file') {
          const file = ev.dataTransfer.items[i].getAsFile();
          loadJSONFile(file, store);
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < ev.dataTransfer.files.length; i++) {
        loadJSONFile(ev.dataTransfer.files[i], store);
      }
    }
  };

  const height = useHeight();
  
  return (
    <div
      style={{
        width: '100vw',
        height: height + 'px',
        display: 'flex',
        flexDirection: 'column',
      }}
      onDrop={handleDrop}
    >
      <div className="bp3-dark" style={{ height: 'calc(100% - 50px)' }}>
        <PolotnoContainer className="polotno-app-container">
          <SidePanelWrap>
            <SidePanel store={store} sections={[...DEFAULT_SECTIONS, UploadSection, SavedSection,GCPPhotosTab,GCPCharactersTab,GCP3dCharactersTab, GCPIllustrationsTab, GCPGraphicsTab, GCPQuotesTab]} />
          </SidePanelWrap>
          <WorkspaceWrap>
            <Toolbar store={store} hideDuplicate downloadButtonEnabled={false} />
            <Workspace store={store} />
            <ZoomButtons store={store} />
          </WorkspaceWrap>
        </PolotnoContainer>
      </div>
    </div>
  );
};

export default App;
